export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getAssistList: function getAssistList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/polish/invite/record",
        method: "get",
        params: data
      });
    },
    // 设备列表
    getDeviceIdList: function getDeviceIdList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/device/list",
        method: "get",
        params: data
      });
    },
    // 风险列表
    getRiskList: function getRiskList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/device/risk/code/list",
        method: "get",
        params: data
      });
    },
    // 备注
    setDeviceIdRemark: function setDeviceIdRemark() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/device/list",
        method: "post",
        data: data
      });
    },
    // 设置/移除高危
    setDeviceIdDanger: function setDeviceIdDanger() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/device/list",
        method: "post",
        data: data
      });
    },
    // 获取感知源数据库
    getDeviceIdSourceList: function getDeviceIdSourceList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/device/perception-source/database/list",
        method: "get",
        params: data
      });
    },
    // 设置感知源
    setDeviceIdSource: function setDeviceIdSource() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/device/list",
        method: "post",
        data: data
      });
    },
    // 设置风险设备和分类
    setRiskDeviceAndCategory: function setRiskDeviceAndCategory() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/user/device/set/risk_and_category",
        method: "post",
        data: data
      });
    },
    // 获取授权场景风险码
    getAuthSceneRiskCodeList: function getAuthSceneRiskCodeList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/device/auth/scene/risk/code/list",
        method: "get",
        params: data
      });
    }
  };
});